import { deleteCustomAlarmDefinitions } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/service/custom-alarm-list.service';
import { showErrorNotification, showSuccessNotification } from 'core/utils/notification-service';
import { useTranslation } from 'core/i18n';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';

export const useCustomAlarmsDeleter = () => {
    const { t } = useTranslation();

    const deleteCustomAlarms = (definitions: CustomAlarmListItem[], onSuccess?: VoidFunction) => {
        const ids = definitions.map((id) => id.id);

        return deleteCustomAlarmDefinitions(ids)
            .then(() => {
                showSuccessNotification(t('settings.devices.custom-alarms.delete.notifications.success'));
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch((error) => {
                showErrorNotification(t('settings.devices.custom-alarms.delete.notifications.error'));
                throw error;
            });
    };

    return {
        deleteCustomAlarm: deleteCustomAlarms,
    };
};
